import { defineStore } from 'pinia';
import api from '@/api';

export const useWipStore = defineStore('wip', {
  state: () => ({
    birthRules: [],
    birthConfig: null,
    wipItems: [],
    orderSummary: [],
    allWipItems: [],
    currentItem: null,
    loading: false,
    error: null
  }),

  getters: {
    getBirthRules: (state) => state.birthRules,
    getBirthConfig: (state) => state.birthConfig,
    getWipItems: (state) => state.wipItems,
    getOrderSummary: (state) => state.orderSummary,
    getAllWipItems: (state) => state.allWipItems,
    getCurrentItem: (state) => state.currentItem,
    isLoading: (state) => state.loading
  },

  actions: {
    async fetchAll(params = {}) {
      this.loading = true;
      this.error = null;
      try {
        const resp = await api.wip.getAll(params);
        this.allWipItems = resp.data || [];
      } catch (e) {
        this.error = e;
        this.allWipItems = [];
        throw e;
      } finally {
        this.loading = false;
      }
    },

    async fetchById(wipItemId) {
      this.loading = true;
      this.error = null;
      try {
        const resp = await api.wip.getById(wipItemId);
        this.currentItem = resp.data;
        return resp.data;
      } catch (e) {
        this.error = e;
        this.currentItem = null;
        throw e;
      } finally {
        this.loading = false;
      }
    },

    async fetchBirthRules() {
      try {
        const response = await api.wip.getBirthRules();
        this.birthRules = response.data || [];
      } catch (error) {
        this.error = error;
        throw error;
      }
    },

    async fetchBirthConfig(lineId) {
      try {
        const response = await api.wip.getBirthConfig(lineId);
        this.birthConfig = response.data || null;
      } catch (error) {
        this.error = error;
        throw error;
      }
    },

    async upsertBirthConfig(lineId, data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.wip.upsertBirthConfig(lineId, data);
        this.birthConfig = response.data;
        return response.data;
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async releaseOrderLine(lineId) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.wip.releaseOrderLine(lineId);
        return response.data;
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async fetchByOrderLine(lineId) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.wip.getByOrderLine(lineId);
        this.wipItems = response.data || [];
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async fetchOrderSummary(orderId) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.wip.getOrderSummary(orderId);
        this.orderSummary = response.data || [];
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    clearWipItems() {
      this.wipItems = [];
      this.birthConfig = null;
    },

    clearCurrentItem() {
      this.currentItem = null;
    }
  }
});
